// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>12</span>&nbsp;&nbsp;For you will deliver my soul from death<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;and my feet from falling,&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;that I may walk before God in the light of the living.<br> </p> </div></div>";
// Exports
module.exports = code;